module.exports = __webpack_public_path__ + "assets/icon-cloud-upload-component.7c18cba7.svg";